import React from 'react';
 
function Footer(){
    return (
      <footer>
        <div className='footer'>
          Copyright &copy; 2024 All Rights Reserved.
        </div> 
      </footer>       
    );
  }
 
export default Footer; 
